export default __webpack_public_path__ + "static/media/53.2f1cdf85.svg";